const classNames = (...classes: any[]) => classes.filter((i) => i).join(' ');

export default classNames;
